export function getGridItemHeight(width: number) {
  return width * (9 / 16) + 125
}
